import React, { useState } from 'react';
import Swal from 'sweetalert2';
import { useHistory } from 'react-router-dom';

// Material-UI
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import ExitIcon from '@material-ui/icons/ExitToAppRounded';
import Container from '@material-ui/core/Container';
import { makeStyles } from "@material-ui/core";

import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';
//service
import loginService from '../services/loginService';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(-2),
  },
  title: {
    flexGrow: 1,
    marginLeft: theme.spacing(-1)
  },
}));

const NavbarTitle = ( props ) => {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const history = useHistory()

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleKeluar = async() => {
    try {
      await loginService.logout();

      return (
        Swal.fire({
          icon: "success",
          title: "Berhasil Keluar!",
          text: "Terima Kasih Calon Anggota Baru ^_^",
        }), history.push('/')
      )
    } catch(e) {
      console.log(e.response)
      if (e.response.data.meta.code !== 401) {
        return (
          Swal.fire({
            icon: "error",
            title: "Gagal Keluar!",
            text: e.response.data.meta.message || e.message || '',
          }), history.push('/')
        )
      } else {
        return (
          Swal.fire({
            icon: "success",
            title: "Berhasil Keluar!",
            text: "Terima Kasih Calon Anggota Baru ^_^",
          }), history.push('/')
        )
      }
    }

  }

  return (
    <nav>
      <AppBar position="static" color="primary">
        <Container>
          <Toolbar>
            <Typography variant="h6" className={classes.title}>
              {props.title}
            </Typography>
            <IconButton 
              edge="end"
              className={classes.menuButton}
              color="inherit"
              aria-label="menu"
              onClick={handleMenu}
            >
              <ExitIcon/>
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorEl}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              open={open}
              onClose={handleClose}
            >
              <MenuItem onClick={handleKeluar}>Keluar</MenuItem>
            </Menu>
          </Toolbar>
        </Container>
      </AppBar>
    </nav>
  )
}

export default NavbarTitle
